import type { Asset, } from "@bracket/types";
import { getDeviceType, getTheme, Flow, Text as Tx, } from "@bracket/ui";
import { PanelItem, } from "@components";
import { formatDollars, formatWEI, } from "@formatters";
import styled from "styled-components";
import { MobileSummaryItem, } from "./MobileSummaryItem";


export declare type TwinSummaryItemProps = {
	label: string;
	value: { usd: number; brkt?: string; perc?: number; };
	value2: { usd: number; brkt?: string; perc?: number; };
	denomination?: Asset;
	tip?: string;
	showDollars?: boolean;
	showAsset?: boolean;
	showPercent?: boolean;
	showPercentOnly?: boolean;
	logo?: string;
	spacing?: string;
	x?: boolean;
	x2?: boolean;
}




export const TwinSummaryItem = ( props: TwinSummaryItemProps ) => {

	if(getDeviceType() === "MOBILE") {
		return <MobileSummaryItem {...props} twinSummary />;
	}

	const {
		label,
		value,
		value2,
		denomination,
		tip,
		showAsset = true,
		showDollars = true,
		showPercent = true,
		showPercentOnly = false,
		logo,
		spacing = "0.25rem",
		x = false,
		x2 = false,
	} = props;


	const {
		symbol,
		decimals,
		label: denominationLabel,
	} = denomination || {};

	if(showPercentOnly) {
		return (
			<PanelItem label={label} tip={tip} logo={logo} direction="row" mobileLogoCenter mobileLabelLeftPad="0.5rem">
				<Tx h6>
					{ typeof value.perc === "number" && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : "%" }</span>) }
				</Tx>
				/
				<Tx h6>
					{ typeof value2.perc === "number" && (<span className="percent">{ x2 ? "" : value2.perc > 0 ? "+" : "" }{ value2.perc.toFixed(2) }{ x2 ? "x" : "%" }</span>) }
				</Tx>
			</PanelItem>
		);
	}

	return (
		<PanelItem color="surface_variant_on" label={label} tip={tip} logo={logo} mobileLogoCenter mobileLabelLeftPad="0.5rem">
		{
			symbol === "USDC" ? (
				<ValueGroup>
					<Tx h6>
						{ showDollars && formatDollars(value.usd) }
						{ showPercent && typeof value.perc === "number" && !isNaN(value.perc) && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : "%" }</span>) }
						{ showPercent && typeof value2.perc === "number" && !isNaN(value2.perc) && (<span className="percent">{ x2 ? "" : value2.perc > 0 ? "+" : "" }{ value2.perc.toFixed(2) }{ x2 ? "x" : "%" }</span>) }
					</Tx>
				</ValueGroup>
			) : (
				<ValueGroup>
					<Tx h6>
						{ showDollars && formatDollars(value.usd) }
						{ showPercent && typeof value.perc === "number" && !isNaN(value.perc) && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : "%" }</span>) }
						{ showPercent && typeof value2.perc === "number" && !isNaN(value2.perc) && (<span className="percent">{ x2 ? "" : value2.perc > 0 ? "+" : "" }{ value2.perc.toFixed(2) }{ x2 ? "x" : "%" }</span>) }
					</Tx>
					{
						showAsset && denomination && value.brkt && (
							<Tx className="brkt-value">
								{formatWEI(value.brkt, decimals, symbol === "USDC" ? 2 : 5)} {denominationLabel}
							</Tx>
						)
					}
				</ValueGroup>
			)
		}
		</PanelItem>
	)
}



const ValueGroup = styled(Flow)`
	span {
		&.percent {
			padding-left: 1rem;
			color: ${() => getTheme().surface_variant_on};
			font-size: 1rem;
			@media (max-width: 768px) {
				display: block;
				padding-left: 0;
				margin-top: .25rem;
				text-align: right;
			}
		}
	}
	> p {
		padding-top: .25rem;
		&.brkt-value {
			padding-top: 0;
		}
		&.perc-value {
			position: absolute;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 1.5rem;
			right: 1rem;
		}
	}
`;
